export default __webpack_public_path__ + "static/media/Mercury.a8ce9133.jpg";